import Api from '@services/api';

export const INTEGRATION_USERS_REQUEST = 'admin/INTEGRATION_USERS_REQUEST';
export const INTEGRATION_USERS_SUCCESS = 'admin/INTEGRATION_USERS_SUCCESS';
export const INTEGRATION_USERS_FAILURE = 'admin/INTEGRATION_USERS_FAILURE';

export type IntegrationUser = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  externalNetworkIds: string[];
  externalFunctionIds: string[];
  status: string;
};

export const fetchIntegrationUsers = (organisationId: string) => async (dispatch: any) => {
  dispatch({ type: INTEGRATION_USERS_REQUEST });

  try {
    const response = await Api.get(`/v1/organisations/${organisationId}/integration/users`);

    dispatch({
      type: INTEGRATION_USERS_SUCCESS,
      data: response.data,
    });

    return response.data;
  } catch (error: any) {
    dispatch({
      type: INTEGRATION_USERS_FAILURE,
      error: error.message || 'Failed to fetch integration users',
    });
    throw error;
  }
};
